export const apiConfig = process.env.VUE_APP_API;
